// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"53799f4e","244":"31e0a6c3","493":"b4607d88","578":"f28eddc3","901":"eec11e3b"}[chunkId] + ".chunk.js";
};